module.exports = __webpack_public_path__ + "static/media/loading-green.267db01f.gif";